import React from 'react';

import css from './message.module.scss';

const Message = ({ text, error }) => {
  if (text) {
    return (
      <div
        className={`${css.Message} ${error ? css.errorMessage : ``}`}
        data-e2e="message"
        data-testid="error-message"
      >
        <p>{text}</p>
      </div>
    );
  }
  return <div />;
};

export default Message;
